// React import
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// Actions import
import {hideNotification, setBlockchain, setPage, showNotification} from "../../actions";
// Svg imports
import { ReactComponent as ArbitrumSvg } from '../../svg-icons/blockchains/arbitrum.svg';
import { ReactComponent as AvalancheSvg } from '../../svg-icons/blockchains/avalanche.svg';
import { ReactComponent as BinanceSmartChainSvg } from '../../svg-icons/blockchains/binance-smart-chain.svg';
import { ReactComponent as BlastSvg } from '../../svg-icons/blockchains/blast.svg';
import { ReactComponent as CeloSvg } from '../../svg-icons/blockchains/celo.svg';
import { ReactComponent as EthereumSvg } from '../../svg-icons/blockchains/ethereum.svg';
import { ReactComponent as FantomSvg } from '../../svg-icons/blockchains/fantom.svg';
import { ReactComponent as LineaSvg } from '../../svg-icons/blockchains/linea.svg';
import { ReactComponent as OptimismSvg } from '../../svg-icons/blockchains/optimism.svg';
import { ReactComponent as PolygonSvg } from '../../svg-icons/blockchains/polygon.svg';
// Consts imports
import {
    BASE, BASE_BLOCKCHAIN, BSC, BSC_BLOCKCHAIN, ETH, ETH_BLOCKCHAIN, PAGE_HOME,
    TAB_AVAILABLE,
    TAB_COMING_SOON
} from "../../consts/consts";
// Styles imports
import './SelectBlockchain.css';
import '../../util.css'

class SelectBlockchain extends React.Component {

    constructor(props) {
        super(props);
        this.state = {openTab: TAB_AVAILABLE};
    }

    setNotification = (message, duration = 750) => {
        const { showNotification, hideNotification } = this.props;
        showNotification({message: message, duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    handleAvailableClick = () => {
        this.setState({openTab: TAB_AVAILABLE});
    }

    handleComingSoonClick = () => {
        this.setState({openTab: TAB_COMING_SOON});
    }

    handleSetBlockchainClick = (blockchain) => {
        const { setPage } = this.props;
        const { setBlockchain } = this.props;
        setBlockchain(blockchain);
        let blockchainName = ETH_BLOCKCHAIN;
        if (blockchain === ETH) {
            blockchainName = ETH_BLOCKCHAIN;
        } else if (blockchain === BASE) {
            blockchainName = BASE_BLOCKCHAIN;
        } else if (blockchain === BSC) {
            blockchainName = BSC_BLOCKCHAIN;
        }
        this.setNotification("Data analysis will take place in " + blockchainName, 1500);
        setPage(PAGE_HOME);
    }

    render () {

        if (this.state.openTab === TAB_AVAILABLE) {

            return(
                <div className={"select-blockchain-page noselect"}>

                    <div className={"select-blockchain-menu"}>
                        <span className={"select-blockchain-menu-item-label-active"} onClick={this.handleAvailableClick}>Available</span>
                        <span className={"select-blockchain-menu-item-label-no-active"} onClick={this.handleComingSoonClick}>Coming soon</span>
                    </div>

                    <div className={"page-area"}>

                        <div className={"select-blockchain-block"} onClick={() => this.handleSetBlockchainClick(BASE)}>
                            <img className={"select-blockchain-icon"}
                                 src="./svg-icons/blockchains/base.png"/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Base</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"} onClick={() => this.handleSetBlockchainClick(BSC)}>
                            <BinanceSmartChainSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>BNB Smart Chain</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"} onClick={() => this.handleSetBlockchainClick(ETH)}>
                            <EthereumSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box  select-blockchain-label-box-no-bottom"}>
                                <span className={"select-blockchain-label "}>Ethereum</span>
                            </div>
                        </div>


                    </div>
                </div>


            );
        } else if (this.state.openTab === TAB_COMING_SOON) {
            return (
                <div className={"select-blockchain-page noselect"}>

                    <div className={"select-blockchain-menu"}>
                        <span className={"select-blockchain-menu-item-label-no-active"}
                              onClick={this.handleAvailableClick}>Available</span>
                        <span className={"select-blockchain-menu-item-label-active"}
                              onClick={this.handleComingSoonClick}>Coming soon</span>
                    </div>

                    <div className={"page-area"}>

                        <div className={"select-blockchain-block"}>
                            <ArbitrumSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Arbitrum</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"}>
                            <AvalancheSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Avalanche</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"}>
                            <BlastSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Blast</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"}>
                            <CeloSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Celo</span>
                            </div>
                        </div>


                        <div className={"select-blockchain-block"}>
                            <FantomSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Fantom</span>
                            </div>
                        </div>


                        <div className={"select-blockchain-block"}>
                            <LineaSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Linea</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"}>
                            <OptimismSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Optimism</span>
                            </div>
                        </div>


                        <div className={"select-blockchain-block"}>
                            <PolygonSvg className={"select-blockchain-icon"}/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Polygon</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"}>
                            <img className={"select-blockchain-icon"}
                                 src="./svg-icons/blockchains/scroll.png"/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Scroll</span>
                            </div>
                        </div>


                        <div className={"select-blockchain-block"}>
                            <img className={"select-blockchain-icon"}
                                 src="./svg-icons/blockchains/solana.png"/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>Solana</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"}>
                            <img className={"select-blockchain-icon"}
                                 src="./svg-icons/blockchains/ton.png"/>
                            <div className={"select-blockchain-label-box"}>
                                <span className={"select-blockchain-label "}>The Open Network</span>
                            </div>
                        </div>

                        <div className={"select-blockchain-block"}>
                            <img className={"select-blockchain-icon"}
                                 src="./svg-icons/blockchains/tron.png"/>
                            <div className={"select-blockchain-label-box  select-blockchain-label-box-no-bottom"}>
                                <span className={"select-blockchain-label "}>TRON</span>
                            </div>
                        </div>


                    </div>
                </div>


            );
        } else {
            return null;
        }

    }

}

const mapStateToProps = ({blockchain, notification}) => ({blockchain, notification});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setBlockchain: setBlockchain,
            showNotification: showNotification,
            hideNotification: hideNotification,
            setPage: setPage
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SelectBlockchain);
